import { Subdimensiones } from '../../../../../interfaces/Evaluations';
import EvaluationStates from '../../../../../components/States/EvaluationStatesCircle';
import { allYears, hasValidEvaluation } from '../../../utils/evaluationHelpers';
import LawsHeaderRow from './LawsHeaderRow';
import EvaluationRowsMultiple from './EvaluationRowMultiple';
import SubdimensionLink from '../../../utils/SubdimensionLink';

interface FixedTableStructuralProps {
    evaluation_subDimension: Subdimensiones[];
    period: string;
    selected_type_indicator: { name: string, id: number };
    selected_dimension: { name: string, id: number } | null;
    right: { right: string, rightId: string };
}

const FixedTable = ({ evaluation_subDimension, period, selected_type_indicator, selected_dimension, right }: FixedTableStructuralProps) => {

    return (
        <div className="flex w-full border rounded-sm border-system-light-50">
            {/* Tabla fija de subdimensiones y estado */}
            <div className="w-[350px]">
                <div className="w-[350px]">
                    <div className="text-llarge text-primary-100 bg-primary-200 px-4 py-4 flex justify-between rounded-tl-sm">
                        <span className="header-cell">SUBDIMENSIONES</span>
                        <span className='w-[55px]'>ESTADO</span>
                    </div>
                </div>

                <div className="w-[350px] bg-brand-green-1">
                    {evaluation_subDimension.map((row, rowIndex) => {
                        const isLongText = row.nombre.length > 57;
                        const displayText = isLongText ? `${row.nombre.substring(0, 57).trim()}...` : row.nombre;

                        return (
                            <div key={rowIndex} className="border-t border-system-light-50">
                                <div className="flex gap-3 items-center px-4">
                                    <div className='w-[263px] h-[56px] flex items-center'>
                                        <SubdimensionLink
                                            selected_dimension={selected_dimension}
                                            selected_type_indicator={selected_type_indicator}
                                            period={period}
                                            value={displayText}
                                            subdimension={row}
                                            right={right.right}
                                            rightId={right.rightId}
                                            disabled={!hasValidEvaluation(row)}
                                            className='line-clamp-2 text-ellipsis overflow-hidden break-words py-1'
                                            title={row.nombre}
                                        />
                                    </div>
                                    <div className='!w-[65px] flex justify-center items-center h-[56px]'>
                                        <EvaluationStates
                                            status={row.trivalente_subdimension}
                                            size={12}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Tabla desplazable para mostrar las leyes y evaluaciones */}
            <div className="scrollable-table overflow-x-auto w-full max-w-full rounded-r-sm border-l border-l-system-light-50">
                <LawsHeaderRow
                    evaluation_subDimension={evaluation_subDimension}
                    period={period}
                />
                <EvaluationRowsMultiple
                    years={allYears(evaluation_subDimension)}
                    subdimensiones={evaluation_subDimension}
                />
            </div>
        </div>
    );
};

export default FixedTable;
